const value = {
    newCategory: 'Создать категорию',
    newValue: 'Создать значение',
    addButton: 'Создать',
    saveButton: 'Сохранить',
    withValue: 'С выбором значения',
    withTextField: 'С текстовым полем',
  };

export default value;
